import { useQuery } from "@tanstack/react-query";

import { pessoaService } from "@/services/api/PessoaService";
import { PessoaFeriasDTO } from "@/types/pessoa-acesso.type";

export function usePessoaEmFerias() {
  const { data, isLoading } = useQuery<PessoaFeriasDTO[]>({
    queryKey: ["pessoa-em-ferias"],
    queryFn: () => pessoaService.getPessoasEmFerias(),
  });

  return { pessoas: data ?? [], loading: isLoading };
}
